// eslint-disable-next-line import/no-cycle
import {
  GET_MUKEBS,
  MUKEBS,
  MUKEB_ERROR,
  MUKEB_SUCCESS,
  UPDATE_MUKEB,
  CREATE_MUKEB,
  FEATURES,
  GET_FEATURES,
  UPDATE_ACTION_STATUS_MUKEB,
  ADMIN_ITEMS,
  GET_OLD_MUKEB,
  OLD_MUKEBS,
} from 'redux/actions';

export const getFeatures = () => {
  return {
    type: GET_FEATURES,
    payload: {},
  };
};

export const getMukebs = (filter) => {
  return {
    type: GET_MUKEBS,
    payload: { filter },
  };
};

export const getOldMukeb = (mobile) => {
  return {
    type: GET_OLD_MUKEB,
    payload: { mobile },
  };
};

export const updateActionMukeb = (status) => {
  return {
    type: UPDATE_ACTION_STATUS_MUKEB,
    payload: { status },
  };
};

export const updateMukeb = (mukeb, id) => {
  return {
    type: UPDATE_MUKEB,
    payload: { mukeb, id },
  };
};

export const createMukeb = (mukeb) => {
  return {
    type: CREATE_MUKEB,
    payload: mukeb,
  };
};

export const mukebs = ({ mukebs, project }) => {
  return {
    type: MUKEBS,
    payload: { mukebs, project },
  };
};

export const features = (items) => {
  return {
    type: FEATURES,
    payload: items,
  };
};
export const adminItems = (items) => {
  return {
    type: ADMIN_ITEMS,
    payload: items,
  };
};

export const mukebSuccess = (message) => ({
  type: MUKEB_SUCCESS,
  payload: { message },
});

export const mukebError = (message) => ({
  type: MUKEB_ERROR,
  payload: { message },
});

export const oldMukebs = ({ mukeb }) => {
  return {
    type: OLD_MUKEBS,
    payload: { mukeb },
  };
};

export const oldMukebSuccess = (message) => ({
  type: MUKEB_SUCCESS,
  payload: { message },
});

export const oldMukebError = (message) => ({
  type: MUKEB_ERROR,
  payload: { message },
});
